import { Directive, Input, QueryList, ViewChildren } from '@angular/core';
import { MatColumnDef } from '@angular/material/table';

@Directive()
export abstract class FiWrapperTableAdditionalColumns {
    constructor() {}

    @Input() position: number = 0;
    @Input() isHidden: boolean = false;
    @ViewChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;

    getMergedColumnDefs(columnDefs: MatColumnDef[]) {
        if (!this.columnDefs) return columnDefs;
        const additionalColumnDefs = this.columnDefs.toArray();
        columnDefs.splice(this.position, 0, ...additionalColumnDefs);
        return columnDefs;
    }
}
